import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import AgoraVideoCall from "./AgoraVideoCall";

const useQuery = () => new URLSearchParams(useLocation().search);

const VideoCallPage = () => {
  const query = useQuery();
  const patientName = query.get("patientName");
  const channelName = query.get("channelName");
  const appoinID = query.get("appoinID");
  const doctorName = query.get("doctorName");
  const userRole = query.get("userRole") || "patient";

  const [callDuration, setCallDuration] = useState(0);
  const [showWarning, setShowWarning] = useState(false);

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h3 style={styles.headerTitle}>
          Video Call with {userRole === "doctor" ? patientName || "Patient" : doctorName || "Doctor"}
        </h3>
        <div style={styles.timerContainer}>
          <div style={styles.timer}>Call Duration: {formatTime(callDuration)}</div>
          {showWarning && (
            <div style={styles.warning}>⚠️ Your call will end soon</div>
          )}
        </div>
      </div>

      {userRole === "patient" ? (
        <AgoraVideoCall
          channelName={channelName || "defaultChannel"}
          patientName={patientName || "Patient"}
          onClose={() => window.close()}
          appoinID={appoinID || ""}
          onCallDurationUpdate={setCallDuration}
          onWarningTrigger={setShowWarning}
          userRole={userRole}
        />
      ) : (
        <AgoraVideoCall
          channelName={channelName || "defaultChannel"}
          doctorName={doctorName || "Doctor"}
          onClose={() => window.close()}
          appoinID={appoinID || ""}
          onCallDurationUpdate={setCallDuration}
          onWarningTrigger={setShowWarning}
          userRole={userRole}
        />
      )}
    </div>
  );
};

const styles = {
  page: {
    height: "93.5vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 15px",
    background: "#3f81c3ff",
    color: "white",
    borderBottom: "2px solid #34495e",
  },
  headerTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  timerContainer: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  timer: {
    fontSize: "16px",
    fontWeight: "bold",
    background: "rgba(255, 255, 255, 0.1)",
    padding: "8px 16px",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
  },
  warning: {
    background: "#e74c3c",
    padding: "8px 12px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "500",
    animation: "pulse 2s infinite",
  },
};

export default VideoCallPage;
